<ng-container *ngIf="totalRecords">
    <div
        style="
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 1% 0%;
        "
    >
        <div
            style="
                display: flex;
                flex-direction: row;
                width: 100%;
                justify-content: space-between;
                padding: 1rem 1rem;
                align-items: center;
            "
        >
            <div class="page-show-count">
                <span
                    >Showing

                    <b>
                        {{ (currentPage - 1) * pageSize + 1 }}
                        -
                        {{
                            totalRecords < currentPage * pageSize
                                ? totalRecords
                                : currentPage * pageSize
                        }}
                    </b>

                    of {{ totalRecords }} {{ recordType || 'reports' }}</span
                >
            </div>

            <div
                style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 1% 0%;
                    width: 60%;
                "
                *ngIf="totalPages > 1"
            >
                <div style="display: flex; flex-direction: row">
                    <div
                        class="pagination-div-ind"
                        (click)="previousPage()"
                        [ngClass]="{ disable: currentPage === 1 }"
                    >
                        <img src="assets/icons/chevron_left_24px.svg" />
                    </div>

                    <div
                        class="pagination-div-ind"
                        (click)="pageSelect(page)"
                        [ngClass]="{ selected: currentPage === page }"
                        *ngFor="let page of pageList"
                    >
                        <span>{{ page }}</span>
                    </div>

                    <div
                        class="pagination-div-ind"
                        (click)="nextPage()"
                        [ngClass]="{ disable: currentPage === totalPages }"
                    >
                        <img src="assets/icons/chevron_right_24px.svg" />
                    </div>
                </div>
            </div>
            <div
                class="paginator-size flex-row-center"
                style="margin-left: auto"
            >
                <span>Show&nbsp;</span>
                <div
                    class="flex-row-center page-select"
                    [matMenuTriggerFor]="pageSizeMenu"
                >
                    <span>{{ pageSize }}</span>
                    <img src="assets/icons/arrow_drop_down_24px.svg" />
                </div>
                <span>&nbsp;per page</span>
            </div>
            <mat-menu #pageSizeMenu="matMenu">
                <button
                    *ngFor="let size of [10, 20, 30]"
                    [ngClass]="{ 'selected-pagesize': size === pageSize }"
                    (click)="changePageSizeEvent(size)"
                    mat-menu-item
                >
                    {{ size }}
                </button>
            </mat-menu>
        </div>
    </div>
</ng-container>
